const FakeInputAutofill = () => {
    return (
        <>
            <input type="text" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="fakeUsernameBlockAutofill" />
            <input type="password" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="fakePasswordBlockAutofill" />
            <input type="email" aria-autocomplete="list" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="fakeEmailBlockAutofill" />
            <input type="password" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="fakePasswordBlockAutofill" />
            <input type="text" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="_email" />
            <input type="text" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="_password" />
            <input type="text" aria-autocomplete="both" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="EmailFakeTextBlockAutofill" autoComplete="email" />
            <input type="text" aria-autocomplete="both" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="E-mailFakeTextBlockAutofill" autoComplete="e-mail" />
            <input type="password" style={{ position: "absolute", top: -9999999, left: -9999999, opacity: 0 }} name="fakePasswordBlockAutofill" />
        </>
    );
};

export default FakeInputAutofill;
